import createAPI from '../axios'

// 学业预警相关API
const academicWarning = {
	academicWarning: {
	    list: config => createAPI('/academicWarning/list', 'post', config),
        initOption: config => createAPI('/academicWarning/initOption', 'post', config),
        classInfoOption: config => createAPI('/academicWarning/classInfoOption', 'post', config),
		checkResult: config => createAPI('/academicWarning/checkResult', 'post', config),
        multipleExport:config => createAPI('academicWarning/multipleExport','post',config),
        remind: config => createAPI('/academicWarning/remind', 'post', config),
        deptWarnOption: config => createAPI('/academicWarning/deptWarnOption', 'post', config),
        majorWarnOption: config => createAPI('/academicWarning/majorWarnOption', 'post', config),
        majorWarnSetOption: config => createAPI('/academicWarning/majorWarnSetOption', 'post', config),
        queryWarnSet: config => createAPI('/academicWarning/queryWarnSet', 'post', config),
        saveWarnSet: config => createAPI('/academicWarning/saveWarnSet', 'post', config),
        initQueryCombo: config => createAPI('/academicWarning/initQueryCombo', 'post', config),
        loadMajorInfo: config => createAPI('/academicWarning/loadMajorInfo', 'post', config),
	}
};

export default academicWarning;



// WEBPACK FOOTER //
// ./src/api/modules/academicWarning.js